angular.module('admin.services')

.service('AuthResolver', ['API_VARS', 'AccountService', 'AgentService', function(API_VARS, AccountService, AgentService){
  let currentUser;
  let fetchCurrentUser =
    AgentService.getCurrentUser()
      .then((user) => {
        AccountService.set(user);
        currentUser = user;
        return user;
      });

  return {
    identifyUser(){
      if(currentUser){
        return Promise.resolve(currentUser);
      }else{
        return fetchCurrentUser;
      }
    },
  }

}]);
